import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ExportResult } from '../models/export-result.model';
import { Utils } from '../utils/utils';
import { GenericBaseService } from './generic-base.service';
import { UrlService } from "./url.service";

@Injectable({
  providedIn: 'root'
})

export class FinancialTransactionService extends GenericBaseService {

  get httpHheaders(): HttpHeaders {
    return new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
  }

  constructor(
    protected httpClient: HttpClient,
    protected toastrService: ToastrService,
    public datePipe: DatePipe,
    protected url: UrlService
  ) {
    super('Financial Transaction', httpClient, toastrService, url);
  }

  getExportResult(companyId: number, fromDate: string, toDate: string) {
    if (Utils.isValidStringDate(fromDate) && Utils.isValidStringDate(toDate)) {
      let result: any;

      var exportResult = new ExportResult(companyId, fromDate, toDate);

      result = this.httpClient.post<string>(this.getApiUrl('/financial-transaction/export/'), this.getBody(exportResult),
        {headers: this.httpHheaders, responseType: 'text/csv' as 'json'});

      result.subscribe((csvContentResult: string) => {
        var fileName: string = "Export financial transactions " + this.datePipe.transform(Date.now(), "dd-MM-yyyy HH.mm") + ".csv";
        Utils.createHyperLinkForDownload(fileName, csvContentResult, 'text/csv');
      });
    } else {
      this.toastrService.error("No valid period provided for the export");
    }
  }
}
